import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function Donations() {
  const { t } = useTranslation()
  const [copied, setCopied] = useState<string | null>(null)

  const address = '0x6cd859610649bF1774b5248e52a5e573cd1377a6'

  const handleCopy = (text: string, key: string) => {
    navigator.clipboard.writeText(text)
    setCopied(key)
    setTimeout(() => setCopied(null), 1200)
  }

  return (
    <section
      id='alternative-donations'
      className='mt-12 max-w-xl px-4 border-t border-gray-300 flex flex-col gap-4 pt-6 items-center'
    >
      <p className='text-gray-300 mt-8 text-sm font-semibold mb-2'>{t('donateVia')}</p>

      <ul className='w-full flex flex-col gap-6 items-center'>
        <li className='flex items-center justify-center w-full text-gray-200 text-center flex-wrap gap-2 sm:gap-4'>
          {/* Label */}
          <span className='flex items-center gap-2'>
            <span aria-hidden='true'>🇬🇧</span>
            <a
              href='http://ukrainecp.org/supporting-kherson/#ChristmasAppeal'
              target='_blank'
              rel='noreferrer'
              className='underline'
            >
              {t('charityRef')}
            </a>
          </span>

          {/* Address + button */}
          <div className='relative flex items-center gap-2 min-w-0 max-w-full'>
            <span className='text-sm opacity-70 text-blue-400 truncate max-w-[70vw]'>
              &quot;for Anti Human Safari Project&quot;
            </span>

            <button
              onClick={() => handleCopy('"for Anti Human Safari Project"', 'charity')}
              className='text-xs px-2 py-1 border border-gray-400 rounded hover:bg-gray-700 transition cursor-pointer active:bg-gray-400 whitespace-nowrap'
            >
              {t('copy')}
            </button>

            {copied === 'charity' && (
              <span
                className='
                  absolute -top-6 left-1/2 -translate-x-1/2
                  text-xs bg-gray-800 text-white px-2 py-1 rounded
                  animate-toast
                '
              >
                {t('copied')}
              </span>
            )}
          </div>
        </li>

        <li className='flex items-center justify-center w-full text-gray-200 text-center flex-wrap gap-2 sm:gap-4'>
          {/* Label */}
          <span className='flex items-center gap-2'>
            <span aria-hidden='true'>🇩🇪</span>
            <a
              href='https://fellas4europe.org/spenden/'
              target='_blank'
              rel='noreferrer'
              className='underline'
            >
              {t('germanCharityRef')}
            </a>
          </span>

          {/* Address + button */}
          <div className='relative flex items-center gap-2 min-w-0 max-w-full'>
            <span className='text-sm opacity-70 text-blue-400 truncate max-w-[70vw]'>
              &quot;Save Kherson&quot;
            </span>

            <button
              onClick={() => handleCopy('"Save Kherson"', 'germanCharity')}
              className='text-xs px-2 py-1 border border-gray-400 rounded hover:bg-gray-700 transition cursor-pointer active:bg-gray-400 whitespace-nowrap'
            >
              {t('copy')}
            </button>

            {copied === 'germanCharity' && (
              <span
                className='
                  absolute -top-6 left-1/2 -translate-x-1/2
                  text-xs bg-gray-800 text-white px-2 py-1 rounded
                  animate-toast
                '
              >
                {t('copied')}
              </span>
            )}
          </div>
        </li>
      </ul>
      {/* <ul className='w-full flex flex-col gap-6 items-center'>
        <li className='flex items-center justify-center w-full text-gray-200 text-center flex-wrap gap-2 sm:gap-4'>
          <p className='whitespace-nowrap'>ETH:</p>
          <div className='relative flex items-center gap-2 min-w-0 max-w-full'>
            <span className='text-sm opacity-70 text-blue-400 truncate max-w-[70vw]'>
              {address}
            </span>

            <button
              onClick={() => handleCopy(address, 'eth')}
              className='text-xs px-2 py-1 border border-gray-400 rounded hover:bg-gray-700 transition cursor-pointer active:bg-gray-400 whitespace-nowrap'
            >
              {t('copy')}
            </button>

            {copied === 'eth' && (
              <span
                className='
                  absolute -top-6 left-1/2 -translate-x-1/2
                  text-xs bg-gray-800 text-white px-2 py-1 rounded
                  animate-toast
                '
              >
                {t('copied')}
              </span>
            )}
          </div>
        </li>
      </ul> */}
    </section>
  )
}
